import search from "/services/search";
import events from "/events";

const state = {
  results: null,
  error: false,
  loading: false
};

const getters = {};

const mutations = {
  results: (state, payload) => {
    state.results = payload;
  },
  error: (state) => {
    state.error = true;
  },
  clearError: (state) => {
    state.error = false;
  },
  startLoading: (state) => {
    state.loading = true;
  },
  endLoading: (state) => {
    state.loading = false;
  }
};

const actions = {
  reset: ({ commit }) => {
    commit("results", null);
    commit("endLoading");
    commit("clearError");
  },
  query: ({ commit, rootState }, payload) => {
    commit("startLoading");
    commit("clearError");
    search(payload, rootState.user.supportedLanguages)
      .then((results) => {
        if (results) {
          events.track("header-20200707-search", "2-trigger", `${results.length}-${payload}`);
          results = results.map((r, i) => {
            const searchParams = new URLSearchParams({ r: i + 1, st: payload });
            return {
              ...r,
              url: `${r.url}?${(searchParams.toString())}`
            };
          });
        }
        commit("results", results);
      })
      .catch(() => commit("error"))
      .finally(() => commit("endLoading"));
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
